export default __webpack_public_path__ + "static/media/Paveleen-Kaur.d49920a9.jpg";